<template>
    <div class="tabs">
        <Button 
            v-for="button in currentTabButtons"
            :id="button.id"
            :key="button.type" :active="button.active"
            @click.native="toggleTab(button.type)" type="tab-button">
            {{ button.title }}
        </Button>
    </div>
</template>

<script>
import Button from '../../Button'
import {useRouter, useTabsButtons} from '../../../../../core/hooks'
import {computed, watch} from '@vue/composition-api'
export default {
    name: 'Tabs',
    components: {
        Button
    },
    setup(props, context) {
        const { currentTabButtons, setTab } = useTabsButtons()
        const { route, router } = useRouter()


        watch(route, (newRoute, oldRoute) => {
            if(newRoute.query.type !== oldRoute.query.type) {
                let index = currentTabButtons.value.findIndex(item => item.type === newRoute.query.type);
                if(index === -1) {
                    index = 0;
                }

                const tabName = currentTabButtons.value[index].title
                context.root.$sendMixpanelEvent(`Dashboard ${tabName} Tab Clicked`)
                context.root.$ga.event('Dashboard', `${tabName} Tab Click`)

                setTab(index)
            }
        })

        const toggleTab = (type) => {
            router.push({
                query: {
                    ...route.value.query,
                    type,
                    page: undefined,
                    id: undefined
                }
            }).catch(e => {})
        }

        return {
            currentTabButtons,
            toggleTab
        }
    }
}
</script>

<style lang="scss" scoped>
    .tabs {
        button:first-child {
            border-radius: 4px 0;
        }
    }
</style>